/**
 * DevExtreme (esm/__internal/grids/data_grid/module_not_extended/search.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { searchModule } from "../../../grids/grid_core/search/m_search";
import gridCore from "../m_core";
gridCore.registerModule("search", searchModule);